import Vue from 'vue';
import Router from 'vue-router';
import index from '../components/index';
import applyStep from '../components/applyStep';
import signApply from '../components/signApply';
import siteBook from '../components/siteBook';
import register from '../components/register';
import allSitePage from '../components/allSitePage';
import detailInfo from '../components/detailInfo';
import updateSiteBaseInfo from '../components/updateSiteBaseInfo';
import mySitePage from '../components/mySitePage';
import notebook from '../components/notebook';
import changeSite from '../components/changeSite';
import updateUserInfo from '../components/updateUserInfo';
import addSiteComplain from '../components/addSiteComplain';
import resetPassword from '../components/resetPassword';
import detailSite from '../components/detailSite';
import logoutSite from '../components/logoutSite';
import newSitePage from '../components/newSitePage';
import notFound from '../components/notFound';
import t404 from '../components/t404';
import SliderVerificationCode from 'slider-verification-code';
import 'slider-verification-code/lib/slider-verification-code.css';
import login from '../components/login';
Vue.use(login)
Vue.use(SliderVerificationCode);
Vue.use(Router)
const titleName = localStorage.getItem('clientTitle')
export default new Router({
 // mode: 'history', //去掉url中的#

  routes: [
    {
      path: "/404",
      name: "notFound",
      component: notFound,
      meta: {
        title: titleName
      }
    },
    {
      path: '/login/:token',
      name: 'login',
      component: login,
      meta: {
        title: titleName
      }
    },
    {
      path: '/',
      redirect: '/newSitePage'
    },
    {
      path: '/notebook',
      name: 'notebook',
      component: notebook
    },
    {
      path: '/logoutSite/:siteBaseId',
      name: 'logoutSite',
      component: logoutSite,
      meta: {
        title: titleName
      },
    },
    {
      path: '/changeSite/:siteBaseId',
      name: 'changeSite',
      component: changeSite,
      meta: {
        title: titleName
      },
    },
    {
      path: '/index',
      name: 'index',
      component: index,
      meta: {
        title: titleName
      },
    },
    {
      path: '/updateSiteBaseInfo/:siteBaseId',
      name: 'updateSiteBaseInfo',
      component: updateSiteBaseInfo,
      meta: {
        title: titleName
      },
    },
    {
      path: '/detailSite/:siteBaseId',
      name: 'detailSite',
      component: detailSite,
      meta: {
        title: titleName
      },
    },
    {
      path: '/t404',
      name: 't404',
      component: t404,
      meta: {
        title: titleName
      },
    },
    {
      path: '/newSitePage',
      name: 'newSitePage',
      component: newSitePage,
      meta: {
        title: titleName
      },
    },
    {
      path: '/updateUserInfo',
      name: 'updateUserInfo',
      component: updateUserInfo,
      meta: {
        title: titleName
      },
    },
    {
      path: '/detailInfo/:siteBaseId',
      name: 'detailInfo',
      component: detailInfo,
      meta: {
        title: titleName
      },
    },
    {
      path: '/mySitePage',
      name: 'mySitePage',
      component: mySitePage,
      meta: {
        title: titleName
      },
    },
    {
      path: '/allSitePage',
      name: 'allSitePage',
      component: allSitePage,
      meta: {
        title: titleName
      },
    },
    {
      path: '/allSitePage',
      name: 'allSitePage',
      component: allSitePage,
      meta: {
        title: titleName
      },
    },
    {
      path: '/register',
      name: 'register',
      component: register,
      meta: {
        title: titleName
      },
    },
    {
      path: '/resetPassword',
      name: 'resetPassword',
      component: resetPassword,
      meta: {
        title: titleName
      },
    },
    {
      path: '/addSiteComplain/:siteBaseId',
      name: 'addSiteComplain',
      component: addSiteComplain,
      meta: {
        title: titleName
      },
    },
    {
      path: '/siteBook',
      name: 'siteBook',
      component: siteBook
    },
    {
      path: '/signApply',
      name: 'signApply',
      component: signApply,
      meta: {
        title: titleName
      },
    },
    {
      path: '/applyStep',
      name: 'applyStep',
      component: applyStep,
      meta: {
        title: titleName
      },
    },
    {
      path:'*',
      redirect:'/404'
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js